import Vue from 'vue';
import { mapGetters } from 'vuex';
import globalTable from '@/mixins/components/table';
import { refreshStates } from '@/mixins/refresh-states';
import dropsLoader from '@/mixins/components/drops-loader';
import tooltip from '@/mixins/components/tooltip';
import { getDynamicData } from './item-types';
import typesMenu from './types-menu';
import AddItem from './add-item';
import EditItem from './edit-item';
import DynamicPage from './dynamic-page';
import DataCategories from './categories';
import DataGroups from './groups';
import DataProductStore from './store';

export default Vue.component('dynamic-data', {
  template: require('./template.html'),
  name: 'dynamic-data',
  mixins: [refreshStates],
  components: {
    typesMenu,
    AddItem,
    EditItem,
    DataCategories,
    DynamicPage,
    DataGroups,
    DataProductStore,
    globalTable,
    dropsLoader,
    tooltip,
  },
  computed: {
    ...mapGetters(['currentSite', 'activeSiteType']),
    dynamicData() {
      return getDynamicData({ type: this.activeSiteType });
    },
    activeData() {
      const { dynamic } = this.currentSite;
      return (dynamic && dynamic[this.activeSiteType]) || {};
    },
    allCategories() {
      return this.activeData.categories || [];
    },
    allGroups() {
      return this.activeData.groups || [];
    },
    rawItemList() {
      return (this.activeData.items || []).filter(item => item.status !== 'deleted');
    },
    hasGroups() {
      return ['media', 'profiles'].includes(this.activeSiteType);
    },
  },
  props: ['modal'],
  data() {
    return {
      loading: false,
      success: false,
      modalContent: null,
      activeItem: null,
      autoSaveLoader: false,
      autoSaveSuccess: false,
      typesMenu: true,
    };
  },
  watch: {
    modal(open) {
      this.$store.dispatch('setGlobalOpenModal', open);
      this.$log.debug(`${this.activeSiteType} data: `, this.activeData);
      if (!open) {
        setTimeout(() => {
          this.activeItem = null;
          this.modalContent = null;
          this.typesMenu = true;
        }, 350);
      }
    },
  },
  mounted() {
    this.refreshState('storePayments', () => {
      this.$emit('toggle-modal');
      this.setActiveType('products');
      this.modalContent = 'store';
    });
  },
  methods: {
    setActiveType(type) {
      this.$store.dispatch('setActiveSiteType', type);
      this.typesMenu = false;
    },
    editItem(item) {
      this.activeItem = item;
      this.modalContent = 'edit-item';
    },
    setLoading(v) {
      this.loading = v;
    },
    setContent(v) {
      this.modalContent = v;
    },
    setActiveItem(v) {
      this.activeItem = v;
    },
    setAutoSaveProp({ key, val }) {
      this[key] = val;
    },
    getColors({ key, value }) {
      const isStatus = key === 'status';
      return {
        'editorUi-successText': isStatus && value === 'published',
        'editorUi-draftText': isStatus && (!value || value === 'not published' || value === 'archived'),
      };
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/index.js